// extracted by mini-css-extract-plugin
export default {"Countdown":"KgPU9","Countdown__inner":"VjUIt","Countdown__label":"y9tBd"};